import NetworkLogic from "../../Shared/NetworkLogic";
import Utils from "../../Shared/Utils";
import Network from "../../Shared/Network";
import Constant from "../../Shared/Constant";
import UIManager from "../../Shared/UIManager";
import AudioManager from "../../Shared/AudioManager";
const i18n = require('LanguageData');

const { ccclass, property } = cc._decorator;

@ccclass
export default class CommitData extends cc.Component {

    @property(cc.Node)
    content: cc.Node[] = [];
    @property(cc.Button)
    btnSubmit: cc.Button = null;
    @property(cc.EditBox)
    editBox: cc.EditBox = null;
    @property(cc.Node)
    NewLab: cc.Node = null;
    private strUrl = null;
    private submitType: string = "";//1  账号 ；2，图片；3：视频
    private id: string = "";
    private applyMode: string = "";

    onLoad() {
        this.node.on("COMMITDATA", this.updateUI.bind(this))
    }

    onEnable() {
        console.log("=====子界面打开")

    }
    updateUI(param) {
        let pa = param.split(",");
        this.id = pa[0];
        this.applyMode = pa[1];
        this.submitType = pa[2];
        cc.log("===this.submitType", this.submitType);
        for (let i = 0; i < this.content.length; i++) {
            this.content[i].active = false;
        }
        this.content[Number(this.submitType) - 1].active = true;
        if (this.submitType === "1") {//提交好友账号
            this.editBox.node.active = true;
            this.editBox.placeholder = i18n.t("Task.friends_account");
            this.NewLab.active = false;
        }
        else if (this.submitType === "2") {//提交图片
            this.editBox.node.active = false;
            this.NewLab.active = true;
            this.NewLab.getChildByName("labHttp").getComponent(cc.Label).string = i18n.t("Task.update_pic")

        } else if (this.submitType === "3") {//提交视频
            this.editBox.node.active = false;
            this.NewLab.active = true;
            this.NewLab.getChildByName("labHttp").getComponent(cc.Label).string = i18n.t("Task.update_video")
        }
        this.btnSubmit.clickEvents[0].customEventData = this.id;
    }

    onBtnClick(event, param) {
        AudioManager.playSound("button");
        console.log("===点击onBtnClick");
        if (param === "close") {
            AudioManager.playSound("close")
            this.node.active = false;
        }
        else if (param === "image") {//上传
            console.log("===点击打开相册");
            Utils.pickImageFromAlbum("image", function (path: string) {
                cc.log("=====打开相册的path", path);
                cc.log(path);
                let sts = path.split("/");
                let fileName = sts[sts.length - 1];
                let size = jsb.fileUtils.getFileSize(path);
                if (size >= 1024 * 1024) {
                    UIManager.showToastUI(i18n.t('Task.pic_limit_size'));
                    return;
                }

                UIManager.showLoadingUI();
                NetworkLogic.uploadFile(fileName, jsb.fileUtils.getDataFromFile(path), function (rec) {
                    console.log("=====上传照片之后返回", rec);
                    //this.editBox.string = rec.url;
                    UIManager.hideLoadingUI();
                    this.strUrl = rec.path;
                    this.NewLab.getChildByName("labHttp").getComponent(cc.Label).string = this.strUrl;
                }.bind(this), function () {
                    cc.log("====照片上传错误");
                }.bind(this))

            }.bind(this));
        }
        else if (param === "video") {//上传视频
            console.log("===点击打开视频");
            Utils.pickImageFromAlbum("video", function (path: string) {
                cc.log("=====打开视频的path", path);
                cc.log(path);
                let sts = path.split("/");
                let fileName = sts[sts.length - 1];
                let size = jsb.fileUtils.getFileSize(path);
                if (size > 1024 * 1024 * 2) {
                    UIManager.showToastUI(i18n.t('Task.video_limit_size'));
                    return;
                }

                UIManager.showLoadingUI();
                NetworkLogic.uploadFile(fileName, jsb.fileUtils.getDataFromFile(path), function (rec) {
                    console.log("=====上传视频之后返回", rec);

                    //this.editBox.string = rec.url;
                    UIManager.hideLoadingUI();
                    this.strUrl = rec.path;
                    this.NewLab.getChildByName("labHttp").getComponent(cc.Label).string = this.strUrl;
                }.bind(this), function () {
                    cc.log("====照片视频错误");
                }.bind(this))

            }.bind(this));
        }
    }
    onBtnSubmit(event, param) {
        AudioManager.playSound("button");
        let data2 = null
        if (this.submitType === "1") {//好友账号
            if (!this.editBox.string) {
                UIManager.showToastUI(i18n.t('Task.inp_account'));
                return;
            }
            data2 = {
                taskId: param,
                friendUserId: this.editBox.string
            }

        } else if (this.submitType === "2") {//照片
            cc.log("=== 点击上传图片 imageUrl：", this.strUrl);
            if (!this.strUrl) {
                UIManager.showToastUI(i18n.t('Task.q_update_pic'));
                return;
            }
            data2 = {
                friendUserId: "",
                taskId: param,
                imageUrl: this.strUrl,
                videoUrl: ""
            }
        }
        else if (this.submitType === "3") {//视频
            if (!this.strUrl) {
                UIManager.showToastUI(i18n.t('Task.q_update_video'));
                return;
            }
            data2 = {
                friendUserId: "",
                taskId: param,
                imageUrl: "",
                videoUrl: this.strUrl
            }
        }
        UIManager.showLoadingUI();
        NetworkLogic.agentApplicationReward(data2, function (rec) {
            UIManager.hideLoadingUI();
            UIManager.showTipUI(i18n.t('datum_text.apply_succ'));

        }, function () {
            console.log("=====提交错误")
        })


    }


    onDestroy(): void {
        this.node.off("COMMITDATA")
    }
}
